module.exports = __webpack_public_path__ + "img/envia.7bfe5157.svg";